import React, { Component } from "react";
import { Form, Col, Button, ButtonToolbar, Spinner } from "react-bootstrap";
import { branchCategoryValidationRules } from "../../../helpers/validationRules";
import { Formik } from "formik";

class ManageBranchCategorySettings extends Component {
  state = {
    id: null,
    name: null,
    maximum: 0,
  };

  pushSubmit = (values, actions) => {
    if (this.props.mode === "Add") {
      this.props.add({
        name: values.name,
        maximum: values.maximum,
      });
    } else {
      this.props.edit({
        id: this.props.data.id,
        name: values.name,
        maximum: values.maximum,
      });
    }
  };

  render() {
    return (
      <Formik
        onSubmit={(values, actions) => {
          setTimeout(() => {
            this.pushSubmit(values, actions);
          }, 2000);
        }}
        validationSchema={branchCategoryValidationRules}
        initialValues={
          this.props.mode === "Add"
            ? {
                name: this.state.name,
                maximum: this.state.maximum,
              }
            : {
                id: this.props.data.id,
                name: this.props.data.name,
                maximum: this.props.data.maximum,
              }
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => {
          return (
            <Form className="p-3 rounded" noValidate onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    isValid={touched.name && !errors.name}
                    isInvalid={touched.name && !!errors.name}
                    type="text"
                    placeholder="Enter name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="maximum">
                  <Form.Label>Maximum</Form.Label>
                  <Form.Control
                    type="number"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.maximum}
                    isValid={touched.maximum && !errors.maximum}
                    isInvalid={touched.maximum && !!errors.maximum}
                    placeholder="Enter maximum"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.maximum}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <ButtonToolbar className="float-right">
                <Button disabled={isSubmitting} type="submit">
                  {isSubmitting ? (
                    <Spinner
                      as="span"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      animation="border"
                    />
                  ) : this.props.mode === "Edit" ? (
                    "Save"
                  ) : (
                    "Create"
                  )}
                </Button>
              </ButtonToolbar>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

export default ManageBranchCategorySettings;
